import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services';

export const authenticationGuard: CanActivateFn = (route, state) => {
  const authenticationService = inject(AuthenticationService);
  return new Promise((resolve, _) => {
    if (!authenticationService.isLoggedIn()) {
      resolve(authenticationService.login(window.location.origin + state.url).then(() => false));
    }
    resolve(true);
  });
};
